import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-right",
  "use": "chevron-right-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"chevron-right\"><path d=\"M3.354.646L7.707 5 3.354 9.354l-.708-.708L6.293 5 2.646 1.354z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol